"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { schemaIsScalarArray } from '../data-field.mjs';
import ArrayFieldValue from './Array.mjs';
import DefaultFieldValue from './Default.mjs';
import ScalarArrayFieldValue from './ScalarArray.mjs';

function DataBuilderFormFieldValue({
  field,
  onChange,
  allowScalarArray,
  refsToIgnoreClick,
  topDropdownPanelComponent
}) {
  if (allowScalarArray && schemaIsScalarArray(field.schema)) {
    return /* @__PURE__ */ jsx(ScalarArrayFieldValue, { field, onChange });
  }
  if (field.schema?.type === "array") {
    return /* @__PURE__ */ jsx("span", { children: /* @__PURE__ */ jsx(
      ArrayFieldValue,
      {
        field,
        onChange,
        refsToIgnoreClick,
        topDropdownPanelComponent
      }
    ) });
  } else {
    return /* @__PURE__ */ jsx(
      DefaultFieldValue,
      {
        field,
        onChange,
        refsToIgnoreClick,
        topDropdownPanelComponent
      }
    );
  }
}

export { DataBuilderFormFieldValue as default };
